export class wipquantityresponse{
    wipQuantity:number
    constructor(wipQuantity:number){
        this.wipQuantity=wipQuantity;
    }
}